import useSetting, { readSetting, writeSetting } from "./hooks/useSetting";

// Kiosk mode: the piece installed somewhere with a mouse and no
// keyboard (the gallery). Nothing may strand the machine — no links
// that navigate away, and Shut Down's end screen heals itself. The flag
// is sticky per machine (localStorage) and set one of two ways:
//   - `?kiosk` in the URL once (`?kiosk=off` clears it), or
//   - mouse-only, no URL change: click the taskbar clock 10 times
//     quickly (toggles) — so staff can flip it by phone instruction.
// The tell that it's on: the About box credits are underlined but no
// longer blue (and no longer links).
export const KIOSK_KEY = "saat.kiosk";

const CLOCK_CLICKS = 10;
// Max gap between consecutive clicks for the run to keep counting.
const CLOCK_CLICK_GAP_MS = 1000;

export function initKioskFromUrl() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("kiosk")) return;
  const raw = params.get("kiosk");
  writeSetting(KIOSK_KEY, !(raw === "off" || raw === "0"));
}

export function useKiosk() {
  return useSetting(KIOSK_KEY, false)[0] === true;
}

// Returns the clock's click handler. Module-level run state: there is
// exactly one taskbar clock.
let run = 0;
let lastAt = 0;
export function onKioskClockClick() {
  const now = performance.now();
  run = now - lastAt <= CLOCK_CLICK_GAP_MS ? run + 1 : 1;
  lastAt = now;
  if (run < CLOCK_CLICKS) return;
  run = 0;
  writeSetting(KIOSK_KEY, readSetting(KIOSK_KEY, false) !== true);
}
